'use client'
import { ExpensesReviewModule } from '@repo/expenses-overtime-review-module/ExpensesReviewModule'

const ExpensesReview = () => {
  return <ExpensesReviewModule />
}

export default ExpensesReview
